import React from 'react';
import { TreeView } from '@material-ui/lab';
import { ExpandMore as ExpandMoreIcon, ChevronRight as ChevronRightIcon } from '@material-ui/icons';

export const TreeContext = React.createContext();

const Tree = props => {
  const ChildComponent = props.childComponent;
  const { onItemSelected, selectedNodeId, initiallySelectedNodeIds } = props;
  const initialContextValue = { ChildComponent, onItemSelected, selectedNodeId };
  return (
    <TreeView defaultCollapseIcon={<ExpandMoreIcon />} defaultExpandIcon={<ChevronRightIcon />} defaultExpanded={initiallySelectedNodeIds}>
      <TreeContext.Provider value={initialContextValue}>
        <ChildComponent path={[]} />
      </TreeContext.Provider>
    </TreeView>
  );
};

export default Tree;
